import { render, staticRenderFns } from "./terms_of_us.vue?vue&type=template&id=2828ef5a&scoped=true&"
import script from "./terms_of_us.vue?vue&type=script&lang=js&"
export * from "./terms_of_us.vue?vue&type=script&lang=js&"
import style0 from "./terms_of_us.vue?vue&type=style&index=0&id=2828ef5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2828ef5a",
  null
  
)

export default component.exports